var _rect, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMedicationRed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 80,
    viewBox: "0 0 81 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.75293,
    width: 80,
    height: 80,
    rx: 40,
    fill: "#FEDEDE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.1096 39.9966H45.8694L44.3866 42.9623C44.3866 42.9623 53.2836 39.9966 56.2493 44.4451C57.6646 46.568 62.5005 50.6435 54.7665 53.3422C51.5383 54.4686 49.4305 55.6081 44.3866 56.3079C41.5729 56.6982 39.9015 59.0517 36.9724 59.2735C31.3709 59.6978 26.5925 53.3422 26.5925 53.3422L25.1096 39.9966Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.4116 40.8817V40.9348L46.4609 40.9151C47.5797 40.4672 48.8003 40.2183 50.1228 40.2183C55.6675 40.2183 60.143 44.6488 60.143 50.0737C60.143 55.4983 55.6678 59.8791 50.1228 59.8791C47.3763 59.8791 44.9348 58.7841 43.1033 57.0415L43.0785 57.0179L43.0537 57.0415C41.1207 58.8835 38.4752 59.979 35.5747 59.979C29.6213 59.979 24.7378 55.2485 24.7378 49.3743V30.6407C24.7378 24.8164 29.6214 20.0359 35.5747 20.0359C41.5281 20.0359 46.4116 24.7665 46.4116 30.6407V40.8817ZM27.2542 39.9466H27.2183V39.9825V49.3243C27.2183 53.841 30.9615 57.5031 35.5747 57.5031C37.8812 57.5031 40.0344 56.6002 41.5727 55.0446L41.5928 55.0243L41.5774 55.0001C40.6623 53.5572 40.1537 51.8653 40.1537 50.0237C40.1537 46.9381 41.6285 44.1507 43.9174 42.3587L43.9312 42.348V42.3305V39.9825V39.9466H43.8952H27.2542ZM42.5831 50.0237V50.0597H42.6191H57.5756H57.6115V50.0237C57.6115 45.9567 54.2256 42.6442 50.0718 42.6442C48.7384 42.6442 47.4562 42.9955 46.3789 43.5979L46.3783 43.5983C45.353 44.2004 44.4813 45.0032 43.8147 45.9567L43.8143 45.9573C43.0448 47.112 42.5831 48.5176 42.5831 50.0237Z",
    fill: "#FAA0A0",
    stroke: "#FAA0A0",
    strokeWidth: 0.0718644
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedicationRed);
export default __webpack_public_path__ + "static/media/medication-red.4d4a9283c3add4043ed5ab541adb7431.svg";
export { ForwardRef as ReactComponent };